import {Component, Input, OnInit} from '@angular/core';
import {MAIL_PLACEHOLDERS} from '@constants/administration/organization/mail-template/mail-placeholders';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';

@Component({
    selector: 'scitis-admin-organization-mail-preview',
    templateUrl: './mail-preview.component.html',
    styleUrls: ['./mail-preview.component.scss'],
    standalone: false
})
export class MailPreviewComponent implements OnInit {

  @Input()
  templateType: string = '';

  @Input()
  subject: string = '';

  @Input()
  message: string = '';

  constructor(private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.subject = this.replacePlaceholdersWithValues(this.subject);
    this.message = this.replacePlaceholdersWithValues(this.message);
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel() {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  private replacePlaceholdersWithValues(text) {
    if (!text || text.length === 0) {
      return text;
    }
    text = text.split(MAIL_PLACEHOLDERS.USER_NAME).join('John Doe');
    text = text.split(MAIL_PLACEHOLDERS.PORTAL).join('Example Portal');
    text = text.split(MAIL_PLACEHOLDERS.URL).join('https://www.example.com');
    text = text.split(MAIL_PLACEHOLDERS.USER_EMAIL).join('john.doe@example.com');
    text = text.split(MAIL_PLACEHOLDERS.USER_PASSWORD).join('topSecretPassword');

    return text;

  }
}
